export default __webpack_public_path__ + "static/media/dribbble_shot.49fe4c39.png";